
import { createContext, useEffect, useState } from "react";

import { ONE_ANSWER_QUESTION_ID, MAX_SCORE } from "../lib/config";

import { findQuestionById } from "../lib/helper";

const INITIAL_ANSWERS = [

  { question_id: 1, answers: null },
  
  { question_id: 2, answers: null },

  { question_id: 3, answers: null },

  { question_id: 4, answers: null },

  { question_id: 5, answers: null },

  { question_id: 6, answers: null },

  { question_id: 7, answers: null },

  { question_id: 8, answers: null },

  { question_id: 9, answers: null },

  { question_id: 10, answers: null },

];

export const AnswerContext = createContext( {

  selectedAnswers: [],

  updateAnswers: () => {},

} );

export function AnswerProvider( { children } ) {

  const [ finalScore, setFinalScore ] = useState( null );

  const [ payload, setPayload ] = useState( null );

  const [ selectedAnswers, setSelectedAnswers ] = useState( () => {

    const savedAnswers = localStorage.getItem( 'answers' );

    return savedAnswers ? JSON.parse( savedAnswers ) : INITIAL_ANSWERS;

  } );

  const updateAnswers = ( id, newAnswer ) => {

    setSelectedAnswers( prev => {

      const question = prev.find( a => a.question_id === id );

      const updatedAnswers = () => {

        if ( !question.answers || ONE_ANSWER_QUESTION_ID.includes( question.question_id ) ) return newAnswer;

        const existingAnswerIds = question.answers?.map( answer => answer.id );

        if ( existingAnswerIds.includes( newAnswer[ 0 ].id ) ) {

          const filtered = question.answers.filter( answer => answer.id !== newAnswer[ 0 ].id );
          
          return filtered.length ? filtered : null;

        } else {

          return [ ...question.answers, ...newAnswer ];

        }

      };

      const updated = prev.map( a => a.question_id === id ? { ...a, answers: updatedAnswers() } : a );

      return updated;

    } );

  };

  const resetAnswers = () => {

    setSelectedAnswers( INITIAL_ANSWERS );

  };

  const answeredAllQuestions = () => selectedAnswers?.every( answer => answer.answers );

  const scoreAnswers = () => {

    if ( ! answeredAllQuestions() ) return null;

    const answers = selectedAnswers.map( answers => answers.answers ).flat().filter( Boolean );

    const rawScore = answers.reduce( ( score, answer ) => score + ( answer.weight ?? 0 ), 0 );

    return Math.floor( ( 1 - ( rawScore ) / MAX_SCORE ) * 99 + 1 );

  };

  const generatePayload = () => {

    if ( ! answeredAllQuestions() ) return null;

    return selectedAnswers.map( answer => {

      const { id, label } = findQuestionById( answer.question_id );

      const answers = Array.isArray( answer.answers ) ?
        
        { answers: answer.answers.map( ( { id, label, value } ) => ( { id, label, value } ) ) } :
        
        { answer: answer.answers };

      return { id, label, ...answers };

    } )

  };

  useEffect( () => {

    localStorage.setItem( 'answers', JSON.stringify( selectedAnswers ) );

    setFinalScore( scoreAnswers() );

    setPayload( generatePayload() );

  }, [ selectedAnswers ] );
  
  return (
    
    <AnswerContext.Provider value={ { resetAnswers, selectedAnswers, updateAnswers, finalScore, payload } }>

      { children }

    </AnswerContext.Provider>

  );

}
